/**
 * @generated SignedSource<<91dab6e801ea9df45d3a8057bda13038>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceContainerPrimary_viewer$data = {
  readonly buyerUrgencyInfo?: {
    readonly itemUrgency: {
      readonly hasUrgencyInfo: boolean | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgencyLazy_buyerUrgencyInfo">;
  } | null;
  readonly itemRead: ReadonlyArray<{
    readonly displayInfo?: {
      readonly ctas: {
        readonly showAcceptOffer: boolean | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_displayInfo" | "PdpRespSidebarBlurbs_displayInfo" | "PdpRespSidebarButtons_displayInfo" | "PdpSharedPromoCode_displayInfo">;
    } | null;
    readonly itemIsOnHold?: boolean | null;
    readonly seller?: {
      readonly isAccessible: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller">;
    } | null;
    readonly skus?: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_sku" | "PdpRespSidebarBlurbs_sku">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"EstimatedValue_item" | "PdpRespDetailTabs_item" | "PdpRespHeroCarousel_item" | "PdpRespIconBubblesWrapper_item" | "PdpRespMarketplaceNotifications_item" | "PdpRespMarketplaceStickyHeader_item" | "PdpRespSharedBreadcrumbs_item" | "PdpRespSharedHeroCarousel_item" | "PdpRespSharedPrintDetails_item" | "PdpRespSharedTitle_item" | "PdpRespSidebarBlurbs_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarDetails_item" | "PdpRespSidebarSellerInfoAndContactLazy_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespSwatchSelector_item" | "PdpSharedDesignYourOwnPillLazy_item" | "PdpSharedEstimateSimilarSoldRange_item" | "PdpSharedEstimateValueBadge_item" | "PdpSharedItemFavorites_item" | "PdpSharedPriceDisplay_item" | "PdpSharedQuantitySelect_item" | "PricingGuidanceInfo_item" | "getPdpEstimateSimilarSold_item" | "pricingGuidanceTracking_item" | "showPricingGuidance_item" | "useShouldShowSimilarSoldItems_item">;
  } | null> | null;
  readonly similarLandingItems: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
  } | null;
  readonly user?: {
    readonly hasMerchandizingPermission: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_user" | "PdpRespHeroCarousel_user" | "PdpRespIconBubblesWrapper_user" | "PdpRespMarketplaceNotifications_user" | "PdpRespMarketplaceStickyHeader_user" | "PdpRespSharedHeroCarousel_user" | "PdpRespSharedPrintDetails_user" | "PdpRespSidebarBlurbs_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarDetails_user" | "PdpRespSidebarSellerInfoAndContactLazy_user" | "PdpRespSimilarItemsLanding_user" | "PdpRespSwatchSelector_user" | "PdpSharedItemFavorites_user" | "PdpSharedPromoCode_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerChatLoader_viewer" | "PdpRespDetailTabs_viewer" | "PdpRespHeroCarousel_viewer" | "PdpRespIconBubblesWrapper_viewer" | "PdpRespSharedHeroCarousel_viewer" | "PdpRespSidebarButtons_viewer" | "PdpRespSidebarDetails_viewer" | "PdpRespSidebarSellerInfoAndContactLazy_viewer" | "PdpSharedEstimateValueBadge_viewer" | "PdpSharedPageTracker_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedRegistrationPromo_viewer" | "PdpSharedRestrictedMaterials_refactor_viewer" | "getPdpEstimateSimilarSold_viewer" | "useShouldShowSimilarSoldItems_viewer" | "useSimilarSoldItemsTracking_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceContainerPrimary_viewer";
};
export type PdpRespMarketplaceContainerPrimary_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceContainerPrimary_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceContainerPrimary_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "RootArgument",
  "name": "isEstimateSimilarSoldVariant"
},
v1 = {
  "kind": "RootArgument",
  "name": "isTrade"
},
v2 = {
  "kind": "RootArgument",
  "name": "itemId"
},
v3 = {
  "kind": "RootArgument",
  "name": "userId"
},
v4 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v5 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v6 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v7 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v8 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v9 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      (v10/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v12 = [
  (v1/*:: as any*/),
  {
    "kind": "RootArgument",
    "name": "priceBookName"
  },
  {
    "kind": "RootArgument",
    "name": "userCountryCode"
  },
  (v3/*:: as any*/)
],
v13 = {
  "kind": "InlineDataFragmentSpread",
  "name": "showPricingGuidance_item",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceHelpers_item",
      "selections": [
        {
          "alias": "recommendedPrice",
          "args": [
            (v6/*:: as any*/),
            (v7/*:: as any*/),
            (v8/*:: as any*/),
            (v9/*:: as any*/)
          ],
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": (v11/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "medianAmount",
              "plural": false,
              "selections": (v11/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "minAmount",
              "plural": false,
              "selections": (v11/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "maxAmount",
              "plural": false,
              "selections": (v11/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": (v12/*:: as any*/)
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*:: as any*/)
},
v14 = [
  (v10/*:: as any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBtSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    (v0/*:: as any*/),
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPDPLargerItemsVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSiderailSellerReviewCombinedVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    },
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "similarItemsCount"
    },
    (v3/*:: as any*/)
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceContainerPrimary_viewer",
  "selections": [
    {
      "condition": "isPdpSiderailSellerReviewCombinedVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDetailTabs_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "condition": "isPDPLargerItemsVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarousel_viewer"
        }
      ]
    },
    {
      "condition": "isPDPLargerItemsVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedPageTracker_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedRestrictedMaterials_refactor_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedRegistrationPromo_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarSellerInfoAndContactLazy_viewer"
        },
        {
          "alias": null,
          "args": [
            (v4/*:: as any*/),
            (v5/*:: as any*/)
          ],
          "concreteType": "BuyerUrgencyInfo",
          "kind": "LinkedField",
          "name": "buyerUrgencyInfo",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedUrgencyLazy_buyerUrgencyInfo"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemUrgencyInfoType",
              "kind": "LinkedField",
              "name": "itemUrgency",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasUrgencyInfo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isPdpSiderailSellerReviewCombinedVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarDetails_viewer"
        }
      ]
    },
    {
      "condition": "afterDisplayOrBtSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarButtons_viewer"
        }
      ]
    },
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getPdpEstimateSimilarSold_viewer",
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "getHasEnoughSimilarSoldItems_viewer",
                  "selections": [
                    {
                      "condition": "isEstimateSimilarSoldVariant",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "alias": "similarSoldItemsResults",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 0
                            },
                            (v4/*:: as any*/)
                          ],
                          "concreteType": "SimilarSoldItemsConnection",
                          "kind": "LinkedField",
                          "name": "similarSoldItems",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalResults",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ]
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": [
                    (v0/*:: as any*/),
                    (v2/*:: as any*/)
                  ]
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ]
        }
      ]
    },
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplayOrBtSsr",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedEstimateValueBadge_viewer"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarSoldItemsTracking_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "itemIsOnHold",
              "args": [
                (v6/*:: as any*/)
              ],
              "kind": "ScalarField",
              "name": "isOnHold",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "kind": "LinkedField",
              "name": "seller",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAccessible",
                  "storageKey": null
                },
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarSellerInfoAndContactLazy_seller"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                (v6/*:: as any*/),
                {
                  "kind": "Literal",
                  "name": "page",
                  "value": "pdp"
                }
              ],
              "concreteType": "ItemDisplayInfo",
              "kind": "LinkedField",
              "name": "displayInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CTADisplay",
                  "kind": "LinkedField",
                  "name": "ctas",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "showAcceptOffer",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedPromoCode_displayInfo"
                },
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarBlurbs_displayInfo"
                    }
                  ]
                },
                {
                  "condition": "afterDisplayOrBtSsr",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarButtons_displayInfo"
                    }
                  ]
                },
                {
                  "condition": "isPdpSiderailSellerReviewCombinedVariant",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespMarketplaceStickyHeader_displayInfo"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSkuType",
              "kind": "LinkedField",
              "name": "skus",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSidebarBlurbs_sku"
                    }
                  ]
                },
                {
                  "condition": "isPdpSiderailSellerReviewCombinedVariant",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespMarketplaceStickyHeader_sku"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "condition": "afterDisplayOrBtSsr",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedPriceDisplay_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarButtons_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedQuantitySelect_item"
                }
              ]
            },
            {
              "condition": "isPdpSiderailSellerReviewCombinedVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespDetailTabs_item"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedTitle_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDesignYourOwnPillLazy_item"
            },
            {
              "condition": "afterDisplay",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EstimatedValue_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PricingGuidanceInfo_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarBlurbs_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedItemFavorites_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSharedPrintDetails_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceNotifications_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarSellerInfoAndContactLazy_item"
                },
                (v13/*:: as any*/),
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "pricingGuidanceTracking_item",
                  "selections": [
                    {
                      "alias": null,
                      "args": [
                        (v6/*:: as any*/),
                        {
                          "kind": "Literal",
                          "name": "isBuyerEstimateEnabled",
                          "value": true
                        },
                        (v7/*:: as any*/),
                        (v8/*:: as any*/),
                        (v9/*:: as any*/)
                      ],
                      "concreteType": "PricingGuidance",
                      "kind": "LinkedField",
                      "name": "pricingGuidance",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "kind": "LinkedField",
                          "name": "price",
                          "plural": false,
                          "selections": (v14/*:: as any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "kind": "LinkedField",
                          "name": "minAmount",
                          "plural": false,
                          "selections": (v14/*:: as any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "kind": "LinkedField",
                          "name": "maxAmount",
                          "plural": false,
                          "selections": (v14/*:: as any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": (v12/*:: as any*/)
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSharedBreadcrumbs_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespIconBubblesWrapper_item"
            },
            {
              "condition": "isPDPLargerItemsVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSharedHeroCarousel_item"
                }
              ]
            },
            {
              "condition": "isPDPLargerItemsVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespHeroCarousel_item"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsLanding_item"
            },
            {
              "condition": "isMultiSku",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSwatchSelector_item"
                }
              ]
            },
            {
              "condition": "isPdpSiderailSellerReviewCombinedVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarDetails_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceStickyHeader_item"
                }
              ]
            },
            {
              "condition": "isEstimateSimilarSoldVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "condition": "afterDisplay",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpSharedEstimateSimilarSoldRange_item"
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "getPdpEstimateSimilarSold_item",
                      "selections": [
                        (v13/*:: as any*/)
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    }
                  ]
                }
              ]
            },
            {
              "condition": "isPdpSimilarSoldItemsModuleVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "condition": "afterDisplayOrBtSsr",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpSharedEstimateValueBadge_item"
                    }
                  ]
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useShouldShowSimilarSoldItems_item"
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v5/*:: as any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": "hasMerchandizingPermission",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "BUYER_FE_MERCH_TOOL"
                }
              ],
              "kind": "ScalarField",
              "name": "hasPermission",
              "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
            },
            {
              "condition": "isPdpSiderailSellerReviewCombinedVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespDetailTabs_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedPromoCode_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespIconBubblesWrapper_user"
            },
            {
              "condition": "isPDPLargerItemsVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSharedHeroCarousel_user"
                }
              ]
            },
            {
              "condition": "isPDPLargerItemsVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespHeroCarousel_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsLanding_user"
            },
            {
              "condition": "isMultiSku",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSwatchSelector_user"
                }
              ]
            },
            {
              "condition": "afterDisplay",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarBlurbs_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedItemFavorites_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSharedPrintDetails_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceNotifications_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarSellerInfoAndContactLazy_user"
                }
              ]
            },
            {
              "condition": "afterDisplayOrBtSsr",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarButtons_user"
                }
              ]
            },
            {
              "condition": "isPdpSiderailSellerReviewCombinedVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSidebarDetails_user"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespMarketplaceStickyHeader_user"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "similarLandingItems",
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "similarItemsCount"
        },
        (v7/*:: as any*/),
        (v4/*:: as any*/),
        {
          "kind": "Literal",
          "name": "useML",
          "value": true
        }
      ],
      "concreteType": "moreLikeThisItemConnection",
      "kind": "LinkedField",
      "name": "moreLikeThisItem",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsLanding_similarItems"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "46786714e1fb3c7110e3c4e71c144b2f";

export default node;
